import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PersoneOffTime_Interface } from 'src/app/Interface/PersoneOffTime_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PersonOffTimeService {

  constructor(private http: HttpClient) { }


  GetOfftime(PeriodDate:number,
    status:number,
    fullname:String,
    StartSearchDate:String,
    EndSearchDate:String): Observable<Array<PersoneOffTime_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/PersoneOff/GetOfftime?PeriodDate="+PeriodDate
      + "&status="+status
      + "&fullname="+fullname
      + "&StartSearchDate="+StartSearchDate
      + "&EndSearchDate="+EndSearchDate).pipe(
      map(data => {
        return data as Array<PersoneOffTime_Interface>
      })
    )
  }

  AddOfftime(startTime: String,
    endTime: String,
    dsc: String,
    requestDate: String): Observable<any> {
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var body = {
      startTime: startTime,
      endTime: endTime,
      dsc: dsc,
      requestDate: requestDate,
      id: 0
    }
    return this.http.post(environment.BaseUrl + "Daro/PersoneOff/AddOfftime", body, { headers }).pipe(
      map(data => {
        return data as any
      })
    )

  }



  GetSingleOfftime(id:number): Observable<any> {
    return this.http.get(environment.BaseUrl + "Daro/PersoneOff/GetSingleOfftime?id="+id).pipe(
      map(data => {
        return data as any
      })
    )
  }

}
